// The Cognito pool password policy, mirrored client-side so the user gets live
// feedback instead of a round-trip rejection. The SERVER IS THE AUTHORITY — this
// only gates the submit button; a policy failure from Cognito is still surfaced
// verbatim (see ClaimApp). Keep in sync with the pool policy on the prod user pool (min length 8).
export interface PasswordRule {
  id: string;
  label: string;
  test: (value: string) => boolean;
}

export const PASSWORD_RULES: PasswordRule[] = [
  { id: 'length', label: 'At least 8 characters', test: (v) => v.length >= 8 },
  { id: 'upper', label: 'An uppercase letter', test: (v) => /[A-Z]/.test(v) },
  { id: 'lower', label: 'A lowercase letter', test: (v) => /[a-z]/.test(v) },
  { id: 'number', label: 'A number', test: (v) => /[0-9]/.test(v) },
];

export const meetsPolicy = (value: string): boolean =>
  PASSWORD_RULES.every((rule) => rule.test(value));
